<tilled-table
  [data]="(usersViewModel$ | async)!"
  [getPageCallback]="getUsers"
  [dataLength]="usersCount$ | async"
  [noDataMainText]="'No users exist'"
  [noDataSecondaryText]="''"
  data-test-id="users-table"
></tilled-table>
